import { logInstantEvent } from "@/lib/instant-telemetry.functions";
import type { InstantEvent } from "@/lib/instant-telemetry-events";

const SESSION_KEY = "easements.instant.session";

/** Stable per-tab id so one visitor's funnel can be read end to end. */
export function instantSessionId(): string {
  if (typeof window === "undefined") return "ssr";
  try {
    const existing = window.sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const next = crypto.randomUUID();
    window.sessionStorage.setItem(SESSION_KEY, next);
    return next;
  } catch {
    return "no-storage";
  }
}

/**
 * Fire-and-forget funnel event. Never throws and never blocks the UI —
 * a telemetry outage must not be able to break the instant report flow.
 */
export function trackInstant(
  event: InstantEvent,
  payload?: {
    address?: string;
    errors?: string[];
    meta?: Record<string, string | number | boolean | null>;
  },
): void {
  if (typeof window === "undefined") return;
  void logInstantEvent({
    data: {
      sessionId: instantSessionId(),
      event,
      ...(payload?.address ? { address: payload.address.slice(0, 400) } : {}),
      ...(payload?.errors ? { errors: payload.errors.slice(0, 10) } : {}),
      ...(payload?.meta ? { meta: payload.meta } : {}),
    },
  }).catch(() => {
    /* ignore */
  });
}
